import { useState } from "react";
import { toast } from "sonner";
import { http } from "@/lib/api";
import { CheckCircle2, Loader2 } from "lucide-react";

export default function ConsultationForm({ testPrefix = "consultation" }) {
  const [form, setForm] = useState({
    full_name: "",
    email: "",
    phone: "",
    country: "",
    study_level: "Bachelor",
    preferred_time: "",
    message: "",
  });
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const change = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (!form.full_name || !form.email) {
      toast.error("Please enter your name and email.");
      return;
    }
    setLoading(true);
    try {
      await http.post("/leads/consultation", form);
      setDone(true);
      toast.success("Consultation request received — we'll confirm a time shortly.");
    } catch (err) {
      toast.error("Something went wrong. Please try again or WhatsApp us.");
    } finally {
      setLoading(false);
    }
  };

  if (done) {
    return (
      <div className="card-sp text-center py-12" data-testid={`${testPrefix}-form-success`}>
        <CheckCircle2 className="w-12 h-12 text-[#D7141A] mx-auto mb-4" />
        <h3 className="font-serif text-2xl text-[#0D1B2A] mb-2">Thank you</h3>
        <p className="text-[#4A5568]">We'll confirm your consultation slot by email.</p>
      </div>
    );
  }

  return (
    <form onSubmit={submit} className="card-sp" data-testid={`${testPrefix}-form`}>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="label-sp">Full name *</label>
          <input className="input-sp" value={form.full_name} onChange={change("full_name")} required data-testid={`${testPrefix}-input-name`} />
        </div>
        <div>
          <label className="label-sp">Email *</label>
          <input className="input-sp" type="email" value={form.email} onChange={change("email")} required data-testid={`${testPrefix}-input-email`} />
        </div>
        <div>
          <label className="label-sp">WhatsApp / Phone</label>
          <input className="input-sp" value={form.phone} onChange={change("phone")} data-testid={`${testPrefix}-input-phone`} />
        </div>
        <div>
          <label className="label-sp">Country</label>
          <input className="input-sp" value={form.country} onChange={change("country")} data-testid={`${testPrefix}-input-country`} />
        </div>
        <div>
          <label className="label-sp">Study level</label>
          <select className="input-sp" value={form.study_level} onChange={change("study_level")} data-testid={`${testPrefix}-input-level`}>
            {["Bachelor","Master","Medicine","Dentistry","PhD","Other"].map(l => <option key={l}>{l}</option>)}
          </select>
        </div>
        <div>
          <label className="label-sp">Preferred time</label>
          <input className="input-sp" placeholder="e.g. weekday evenings CET" value={form.preferred_time} onChange={change("preferred_time")} data-testid={`${testPrefix}-input-time`} />
        </div>
      </div>
      <div className="mt-4">
        <label className="label-sp">What would you like to discuss?</label>
        <textarea className="input-sp min-h-[110px]" value={form.message} onChange={change("message")} data-testid={`${testPrefix}-input-message`} />
      </div>
      <button type="submit" disabled={loading} className="btn-primary mt-6 w-full justify-center" data-testid={`${testPrefix}-submit`}>
        {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : null}
        {loading ? "Sending…" : "Book Expert Consultation"}
      </button>
    </form>
  );
}
